module.exports = __webpack_public_path__ + "static/media/pl.33ccec22.jpg";